import { Routes } from '@angular/router';

export const noAccessRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./no-access.component').then((module) => module.NoAccessComponent),
  },
];
